import { useEffect } from 'react';

import { Routes } from './Routes';

export default function useRefresh(history: any, path: string, resetRoute: string = Routes.HOME.route) {
    let handler: any;

    const refresh = () => {
        
        history(resetRoute);
        localStorage.setItem('previousPath', 'home');
        
        handler = setTimeout(() => history(path), 10);
    };

    // useEffect(() => {
    //     return () => handler && clearTimeout(handler);
    // }, [handler]);

    return refresh;
}
